import React from 'react'

const BlogManager: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="bg-white rounded-lg shadow p-6">
        <h2 className="text-xl font-semibold mb-4">Blog Posts</h2>
        <p className="text-gray-600">
          Blog management functionality will be implemented here.
        </p>
      </div>
    </div>
  )
}

export default BlogManager